/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Meta_DescriptionInputs */

const id_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat pencapaian dan game ${i?.name} di egdata.app`)
};

const ms_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat pencapaian dan permainan ${i?.name} di egdata.app`)
};

const da_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.name}'s achievements og spil på egdata.app`)
};

const de_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entdecken Sie ${i?.name}s Errungenschaften und Spiele auf egdata.app`)
};

const en_us2_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check out ${i?.name} achievements and games on egdata.app`)
};

const es_es2_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre los logros y juegos de ${i?.name} en egdata.app`)
};

const es_mx2_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre los logros y juegos de ${i?.name} en egdata.app`)
};

const fil_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingnan ang mga achievement at laro ni ${i?.name} sa egdata.app`)
};

const fr_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Découvrez les succès et jeux de ${i?.name} sur egdata.app`)
};

const it_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scopri i risultati e i giochi di ${i?.name} su egdata.app`)
};

const hu_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nézd meg ${i?.name} teljesítményeit és játékait az egdata.app-on`)
};

const nl_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekijk de prestaties en games van ${i?.name} op egdata.app`)
};

const no_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sjekk ut prestasjonene og spillene til ${i?.name} på egdata.app`)
};

const pl_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprawdź osiągnięcia i gry ${i?.name} na egdata.app`)
};

const pt_br2_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confira as conquistas e jogos de ${i?.name} em egdata.app`)
};

const pt_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulte as conquistas e jogos de ${i?.name} no egdata.app`)
};

const ro_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vezi realizările și jocurile lui ${i?.name} pe egdata.app`)
};

const fi_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutustu henkilön ${i?.name} saavutuksiin ja peleihin egdata.appissa`)
};

const sv_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kolla in ${i?.name}s prestationer och spel på egdata.app`)
};

const vi_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem thành tích và game của ${i?.name} trên egdata.app`)
};

const tr_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app'te ${i?.name} başarımlarını ve oyunlarını inceleyin`)
};

const cs_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podívejte se na úspěchy a hry uživatele ${i?.name} na egdata.app`)
};

const bg_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вижте постиженията и игрите на ${i?.name} на egdata.app`)
};

const ru_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посмотрите достижения и игры ${i?.name} на egdata.app`)
};

const uk_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перегляньте досягнення та ігри ${i?.name} на egdata.app`)
};

const ar_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصفح إنجازات وألعاب ${i?.name} على egdata.app`)
};

const hi_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app पर ${i?.name} की उपलब्धियाँ और गेम देखें`)
};

const th_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดูความสำเร็จและเกมของ ${i?.name} บน egdata.app`)
};

const ja_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app で ${i?.name} の実績とゲームをチェック`)
};

const zh_cn2_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.name} 在 egdata.app 上的成就和游戏库`)
};

const zh_hant1_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`檢視 ${i?.name} 在 egdata.app 上的成就和遊戲庫`)
};

const ko_profile_meta_description = /** @type {(inputs: Profile_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`egdata.app에서 ${i?.name}님의 도전 과제와 게임을 확인하세요`)
};

/**
* | output |
* | --- |
* | "Check out {name} achievements and games on egdata.app" |
*
* @param {Profile_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_meta_description = /** @type {((inputs: Profile_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_meta_description(inputs)
	if (locale === "ms") return ms_profile_meta_description(inputs)
	if (locale === "da") return da_profile_meta_description(inputs)
	if (locale === "de") return de_profile_meta_description(inputs)
	if (locale === "en-US") return en_us2_profile_meta_description(inputs)
	if (locale === "es-ES") return es_es2_profile_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_profile_meta_description(inputs)
	if (locale === "fil") return fil_profile_meta_description(inputs)
	if (locale === "fr") return fr_profile_meta_description(inputs)
	if (locale === "it") return it_profile_meta_description(inputs)
	if (locale === "hu") return hu_profile_meta_description(inputs)
	if (locale === "nl") return nl_profile_meta_description(inputs)
	if (locale === "no") return no_profile_meta_description(inputs)
	if (locale === "pl") return pl_profile_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_profile_meta_description(inputs)
	if (locale === "pt") return pt_profile_meta_description(inputs)
	if (locale === "ro") return ro_profile_meta_description(inputs)
	if (locale === "fi") return fi_profile_meta_description(inputs)
	if (locale === "sv") return sv_profile_meta_description(inputs)
	if (locale === "vi") return vi_profile_meta_description(inputs)
	if (locale === "tr") return tr_profile_meta_description(inputs)
	if (locale === "cs") return cs_profile_meta_description(inputs)
	if (locale === "bg") return bg_profile_meta_description(inputs)
	if (locale === "ru") return ru_profile_meta_description(inputs)
	if (locale === "uk") return uk_profile_meta_description(inputs)
	if (locale === "ar") return ar_profile_meta_description(inputs)
	if (locale === "hi") return hi_profile_meta_description(inputs)
	if (locale === "th") return th_profile_meta_description(inputs)
	if (locale === "ja") return ja_profile_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_meta_description(inputs)
	return ko_profile_meta_description(inputs)
});
export { profile_meta_description as "profile.meta.description" }